export enum SqlSchemaCompletionLevel {
    Root = 0,
    Children = 1,
}